<template>
    <div
        class="badge"
        :class="classes"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        variant: {
            type: String,
            default: 'alpha'
        },
        linkHref: {
            type: String,
            default: null,
        },
    },

    computed: {
        classes() {
            return [`badge--${this.variant}`];
        }
    }
}
</script>

<style>
.badge {
    @apply text-xs py-2 px-3 flex items-center;

    &--alpha {
        @apply bg-golden-fizz;
    }

    &--beta {
        @apply bg-zircon;
    }

    &--gamma {
        @apply bg-midnight text-white;
    }
}
</style>
